/**
 * BTW toggle: laat bezoekers wisselen tussen prijzen incl. en excl. BTW.
 *
 * Uitgangspunt: prijzen in de winkel worden weergegeven INCLUSIEF BTW
 * (standaard Shopify-instelling "Prices include tax"). De excl.-BTW-prijs
 * wordt clientside berekend op basis van het BTW-percentage in de
 * thema-instellingen (Theme editor > B2B instellingen > BTW-percentage).
 *
 * Dit is een weergave-berekening, geen wijziging van de daadwerkelijke
 * (fiscale) prijsberekening bij checkout - die blijft altijd correct
 * verlopen via Shopify's eigen belastinginstellingen.
 */
(function () {
  var STORAGE_KEY = 'btw-toggle-mode'; // 'incl' | 'excl'
  var root = document.documentElement;
  var scheduled = false;
  var observer;

  function getRate() {
    var val = parseFloat(root.getAttribute('data-btw-rate'));
    return isNaN(val) ? 0.21 : val / 100;
  }

  function getCurrency() {
    return root.getAttribute('data-shop-currency') || 'EUR';
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: getCurrency(),
      }).format(amount);
    } catch (e) {
      return '€ ' + amount.toFixed(2).replace('.', ',');
    }
  }

  function getMode() {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'incl';
    } catch (e) {
      return 'incl';
    }
  }

  function setMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* localStorage niet beschikbaar (bv. privémodus) - toggle werkt dan alleen voor deze paginaweergave */
    }
    applyModeNow();
  }

  function applyModeNow() {
    var mode = getMode();
    var rate = getRate();

    if (observer) observer.disconnect();

    var priceEls = document.querySelectorAll('.js-btw-price');
    for (var i = 0; i < priceEls.length; i++) {
      var el = priceEls[i];
      var cents = parseFloat(el.getAttribute('data-price-cents'));
      if (isNaN(cents)) continue;
      var bpmCents = parseFloat(el.getAttribute('data-bpm-cents'));
      if (isNaN(bpmCents)) bpmCents = 0;

      if (!el.hasAttribute('data-original-html')) {
        el.setAttribute('data-original-html', el.innerHTML);
      }

      if (mode === 'excl') {
        // "Excl. BTW" is hier de netto catalogusprijs: zowel BPM als BTW eruit.
        // BPM wordt eerst van het totaal afgehaald, en het restant wordt
        // vervolgens ontdaan van de BTW (BPM zelf kent geen BTW).
        var taxableCents = cents - bpmCents;
        var exclCents = taxableCents / (1 + rate);
        el.textContent = formatMoney(exclCents);
      } else {
        el.innerHTML = el.getAttribute('data-original-html');
      }
    }

    var labelEls = document.querySelectorAll('.js-btw-label');
    for (var j = 0; j < labelEls.length; j++) {
      var labelEl = labelEls[j];
      var label =
        mode === 'excl'
          ? labelEl.getAttribute('data-excl-label')
          : labelEl.getAttribute('data-incl-label');
      if (label) labelEl.textContent = label;
    }

    var toggleButtons = document.querySelectorAll('.js-btw-toggle-button');
    for (var k = 0; k < toggleButtons.length; k++) {
      toggleButtons[k].setAttribute('aria-pressed', mode === 'excl' ? 'true' : 'false');
    }

    document.body.classList.toggle('btw-mode-excl', mode === 'excl');

    if (observer) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyModeNow();
    });
  }

  // Herbereken prijzen die dynamisch worden toegevoegd (cart drawer, quick add modal, ajax cart updates, enz.)
  observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scheduleApply();
        return;
      }
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-btw-toggle-button');
    if (!button) return;
    setMode(getMode() === 'excl' ? 'incl' : 'excl');
  });

  function init() {
    applyModeNow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
